export default __webpack_public_path__ + "static/media/leg-icon-models.695325cb.png";